import { PhoneVerdict } from '~/enums/PhoneVerdict'
import { PhoneNumber } from '~/utils/PhoneNumber'
import type { TranslateFn } from './TranslateFn'

/** The localized message for a phone verdict; empty for a valid number. */
export function resolvePhoneMessage(t: TranslateFn, verdict: PhoneVerdict): string {
  return verdict === PhoneVerdict.VALID ? '' : t(PhoneNumber.messageKey(verdict))
}
